import {get, post} from '@/utils/httpHelper';

export default {
  async findAllEmailTemplate () {
    const url = `/esg/security/admin/email/findAllEmailTemplate`;
    const body = await get(url);
    return body.data;
  },
  async updateEmailTemplate (emailTemplate) {
    const url = `/esg/security/admin/email/updateEmailTemplate`;
    const body = await post(url, emailTemplate);
    return body.data;
  }
}



// WEBPACK FOOTER //
// ./src/repositories/email.repository.js